import {Injectable} from '@angular/core';
import {AlertStatus} from 'app/core/interfaces/alert.interface';
import {ActiveToast, ToastrService} from 'ngx-toastr';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class ToastrAlertsService {
    alerts$: BehaviorSubject<ActiveToast<any>[]> = new BehaviorSubject<ActiveToast<any>[]>([]);

    get alerts() {
        return this.alerts$.getValue();
    }

    readonly localConfig = {
        progressBar: true,
        closeButton: true,
        disableTimeOut: true,
        preventDuplicates: true,
        positionClass: 'toast-bottom-right',
        enableHtml: true,
    };

    constructor(private toastr: ToastrService) {
        this.alerts$.next(this.toastr.toasts);
    }

    show(alerts: string, status?: string): ActiveToast<any> {
        switch (status) {
            case AlertStatus.info:
                return this.info(alerts);
            case AlertStatus.warning:
                return this.warning(alerts);
            case AlertStatus.error:
                return this.error(alerts);
            default:
                return this.success(alerts);
        }
    }

    info(alert: string, title = ''): ActiveToast<any> {
        return this.toastr.info(alert, title, this.localConfig);
    }

    success(alert: string, title = ''): ActiveToast<any> {
        return this.toastr.success(alert, title, this.localConfig);
    }

    warning(alert: string, title = ''): ActiveToast<any> {
        return this.toastr.warning(alert, title, this.localConfig);
    }

    error(alert: string, title = ''): ActiveToast<any> {
        return this.toastr.error(alert, title, this.localConfig);
    }

    dismiss(name: string) {
        this.alerts.forEach(alert => {
            if (alert.message.toLowerCase() === name.toLowerCase()) {
                this.toastr.remove(alert.toastId);
                return;
            }
        });
    }
}
